export default __webpack_public_path__ + "static/media/Icon.ad72c187.svg";